import { fetchApi } from '@/config/axiosSetting';
import { VehicleDamageAmountTypeParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVehicleDamageAmount/getVehicleDamageAmountQuery.type';

export const vehicleDamageAmountQueryFunction = (
  params: VehicleDamageAmountTypeParams,
): Promise<number> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/damaged/adjusting/vehicle_damage_amount/`,
    {
      params: {
        id: params.id,
        damaged_id: params.damaged_id,
        source: params.source,
      },
    },
  );
};
